import { money, fmtDateTime, METHOD_LABEL } from "@/lib/format";
import { Crest, ThermalBrand } from "@/components/Brand";

const Line = ({ k, v, bold }) => (
  <div className={`row flex justify-between gap-4 py-1 ${bold ? "font-bold" : ""}`}><span>{k}</span><span>{v}</span></div>
);

// End-of-shift handover slip / cashier receipt, rendered for screen, A4 or 80mm
export default function ShiftReport({ report, format = "a4" }) {
  const s = report.shift;
  const thermal = format === "thermal";
  const body = (
    <>
      <div className="center text-center">
        {thermal ? <ThermalBrand /> : (
          <>
            <Crest className="mx-auto h-14 w-14" />
            <div className="big font-display text-lg font-extrabold text-[#182678]">GPRTU INTERCITY</div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-500">Developed by Nacasky Co. Ltd</div>
          </>
        )}
        <div>{s.station_name}</div>
        <div className="big mt-1 font-bold">{s.status === "received" ? "CASH HANDOVER RECEIPT" : "END OF SHIFT REPORT"}</div>
      </div>
      <hr className="my-2 border-dashed border-slate-300" />
      <Line k="Shift no." v={s.number} />
      <Line k="Teller" v={s.teller_name} />
      <Line k="Opened" v={fmtDateTime(s.opened_at)} />
      <Line k="Closed" v={s.closed_at ? fmtDateTime(s.closed_at) : "OPEN"} />
      <hr className="my-2 border-dashed border-slate-300" />
      <Line k="Opening balance" v={money(s.opening_float)} />
      <Line k={`Tickets sold (${s.transactions || 0} txns)`} v={s.tickets || 0} />
      <Line k="Cash sales" v={money(s.cash_total)} />
      {s.carry_in_total ? <Line k="Cash received from other tellers" v={money(s.carry_in_total)} /> : null}
      {s.transfers_out_total ? <Line k="Cash given to teller / station" v={`- ${money(s.transfers_out_total)}`} /> : null}
      <Line k="Mobile Money" v={money(s.momo_total)} />
      <Line k="Card" v={money(s.card_total)} />
      <Line k="Refunds (cash out)" v={`- ${money(s.refund_total)}`} />
      <Line k={`Cancellation charges kept (${s.cancel_fees_count || 0})`} v={money(s.cancel_fees_total || 0)} />
      <Line k="Gross sales" v={money(s.gross_total)} bold />
      <hr className="my-2 border-dashed border-slate-300" />
      <Line k="CASH TO HAND OVER" v={money(s.expected_cash)} bold />
      {s.declared_cash != null && <Line k="Declared by teller" v={money(s.declared_cash)} />}
      {s.declared_variance != null && <Line k="Declared variance" v={money(s.declared_variance)} />}
      {s.status === "received" && (
        <>
          <hr className="my-2 border-dashed border-slate-300" />
          <Line k="Receipt no." v={s.receipt_no} />
          <Line k="Counted by cashier" v={money(s.received_cash)} bold />
          <Line k="Variance" v={money(s.variance)} bold />
          <Line k="Received by" v={s.received_by} />
          <Line k="Received at" v={fmtDateTime(s.received_at)} />
        </>
      )}
      {!thermal && report.payments?.length > 0 && (
        <table className="mt-4 w-full text-left text-xs">
          <thead><tr className="border-b border-slate-300"><th className="py-1">Time</th><th>Booking</th><th>Route</th><th>Type</th><th>Method</th><th className="text-right">Amount</th></tr></thead>
          <tbody>
            {report.payments.map((p) => (
              <tr key={p.id} className="border-b border-slate-100"><td className="py-1">{fmtDateTime(p.created_at)}</td><td className="font-mono">{p.code}</td><td>{p.route}</td><td>{p.kind === "carry_in" ? "Cash in" : p.kind === "transfer_out" ? "Cash out" : p.kind}</td><td>{METHOD_LABEL[p.method]}</td><td className="text-right">{p.kind === "refund" ? "-" : ""}{money(p.amount)}</td></tr>
            ))}
          </tbody>
        </table>
      )}
      <div className="mt-8 grid grid-cols-2 gap-6 text-xs">
        <div className="border-t border-slate-400 pt-1">Teller signature</div>
        <div className="border-t border-slate-400 pt-1">Cashier signature</div>
      </div>
      <div className="center mt-3 text-center text-[10px]">Printed {fmtDateTime(new Date().toISOString())}</div>
    </>
  );
  return <div className={thermal ? "thermal" : "a4 text-sm"} data-testid="shift-report">{body}</div>;
}
